export default __webpack_public_path__ + "static/media/desk_fury.6143ef3c.png";